import React from "react";
import Sidebar from "./LeftSidebar";
import { sections } from "./sections";
import { useLocation } from "react-router-dom";
import AgentStatusDrawer from "./AgentStatusDrawer";

const Layout = ({ children }) => {
  const location = useLocation();

  const hideSidebar =
    location.pathname.startsWith("/login") ||
    location.pathname.startsWith("/signup");

  if (hideSidebar) {
    return <>{children}</>;
  }

  return (
    <div className="flex">
      {/* Sidebar (fixed) */}
      <div className="hidden md:block">
      <Sidebar sections={sections} />
        </div>
      {/* Main Content */}
      <div className="flex-1 w-full min-h-screen md:pl-16">
        {children}
      </div>
      <AgentStatusDrawer />
    </div>
  );
};

export default Layout;